<script lang="ts">
	import { page } from '$app/stores';
	import { getPostContextStore } from '$lib/components/Post/postContextStore';
	import { getHubStores } from '$lib/stores/hubStores';
	import { _ } from 'svelte-i18n';

	export let target = '_self';
	export let anchor = '';
	const { hub } = getHubStores();
	const post = getPostContextStore();

	let externalSource = $hub.settings.open_external_source || $post.etc?.link_to_source;
	let linkTarget = externalSource ? '_blank' : target;

	let url = new URL(`${$page.url.origin}/${$page.params.hubPrefix}/posts/post-${$post.id}`);

	if (externalSource && $post.url) {
		url = new URL($post.url);
	}

	if (anchor != '') {
		url.hash = anchor;
	}
</script>

<a
	href={url.toString()}
	class="px-context px-slab-context"
	rel="noopener noreferrer"
	target={linkTarget}
	aria-label={anchor == 'contributions'
		? $_('hubs.post.accessibility.tile.footer.comment.icon', {
				values: { postTitle: $post.title },
		  })
		: $_('hubs.post.accessibility.tile.body')}
>
	<slot />
</a>

<style>
	a {
		display: flex;
		position: relative;
		flex-wrap: wrap;
		inline-size: 100%;
		color: var(--hubBodyFontColor);
		text-decoration: none !important;
	}
</style>
